// extracted by mini-css-extract-plugin
export var cardHeader = "_ic-0";
export var reorderHandle = "_ic-3";
export var titleArea = "_ic-1";
export var titleAreaWithHandle = "_ic-2";